<template>
  <section>
    <div class="mb-8">
      <div class="md:flex justify-between mt-1">
        <h6
          class="text-xl font-semibold leading-normal mt-0 mb-4 text-gray-dark"
        >
          Transaction History
        </h6>
        <DateFilter
          :handleDateChange="handleDateChange"
          :handleDateFilterCategoryChange="handleDateFilterCategoryChange"
          :dateFilterCategory="dateFilterCategory"
          :monthOfMonthAndYear="monthOfMonthAndYear"
          monthOfMonthAndYearId="monthOfMonthAndYear"
          yearOfMonthAndYearId="yearOfMonthAndYear"
          yearId="year"
          startDateId="startDate"
          endDateId="endDate"
          :yearOfMonthAndYear="yearOfMonthAndYear"
          :year="year"
          :startDate="startDate"
          :endDate="endDate"
        />
      </div>
      <TableAlt :thead="tableHead">
        <tbody
          v-if="transactionHistoryData && transactionHistoryData.length"
          class="bg-white divide-y divide-gray-200"
        >
          <tr
            v-for="transaction in transactionHistoryData"
            :key="transaction.transfer_uuid"
          >
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-dark">
              <div class="flex md:flex-row flex-col items-center">
                <Avatar
                  :classStr="'h-10 w-10 lg:ml-0 ml-3 xl:mr-2 md:mr-10 lg:mr-4'"
                  :src="baseUrlSrc(transaction && transaction.thumbnail_url)"
                />
                <span class="capitalize">
                  {{ transaction.f_name + " " + transaction.l_name }}
                </span>
              </div>
            </td>
            <td
              class="px-6 py-4 whitespace-nowrap text-sm text-gray-dark capitalize"
            >
              {{
                transaction.entity_type === 1
                  ? transaction.session_title
                  : transaction.course_title
              }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-dark">
              {{ transaction.transaction_id }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-dark">
              {{ handleMonthDateTime(transaction.updated_at, "time") }}
            </td>
            <td
              class="px-6 py-4 whitespace-nowrap text-sm text-gray-dark text-center"
            >
              ${{ transaction.total_amount }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-dark">
              <!-- {{ paymentStatus[transaction.payment_status] }} -->
              {{ transaction.transaction_status }}
            </td>
          </tr>
        </tbody>
      </TableAlt>
      <div v-if="loadingStatus">
        <p class="text-center">Loading...</p>
      </div>
      <div v-else>
        <div v-if="!transactionHistoryData">
          <EmptyTable :description="'Try adjusting the filters to see more.'" />
        </div>
      </div>
      <Pagination
        v-if="transactionHistoryData && transactionHistoryData.length"
        :currentPage="currentPage"
        :handlePageChange="handlePageChange"
        :totalPages="totalPages"
      />
    </div>
  </section>
</template>
<script>
import {
  TableAlt,
  Avatar,
  Pagination,
  EmptyTable,
} from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import DateFilter from "@/components/DateFilter.vue";

export default {
  name: "EarningsHistory",
  components: {
    TableAlt,
    Avatar,
    DateFilter,
    Pagination,
    EmptyTable,
  },
  data() {
    return {
      tableHead: ["USER", "SESSION", "UNIQUE ID", "DATE", "AMOUNT", "STATUS"],
      dateFilterCategory: "month",

      yearOfMonthAndYear: "",
      monthOfMonthAndYear: "",
      year: "selectyear",
      startDate: "",
      endDate: "",
      transactionHistoryData: [],
      currentPage: 1,
      totalPages: "",

      // paymentStatus: {
      //   0: "NOT_NEEDED",
      //   1: "Pending",
      //   2: "PROCESSING",
      //   3: "COMPLETE",
      //   4: "FAILED",
      // },
    };
  },
  computed: {
    ...mapGetters(["trainerTransactionsHistory"]),

    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  methods: {
    ...mapActions(["getTrainerTransactionsHistory"]),

    handleDateFilterCategoryChange(event) {
      this.dateFilterCategory = event.target.value;
    },

    async handleDateChange(event) {
      let startDate = null;
      let endDate = null;
      if (event.target.id === "startDate") {
        startDate = event.target.value;
        endDate = this.endDate;
      } else if (event.target.id === "endDate") {
        endDate = event.target.value;
        startDate = this.startDate;
      } else if (event.target.id === "monthOfMonthAndYear") {
        const month = Number(event.target.value);
        const year = this.yearOfMonthAndYear;
        this.monthOfMonthAndYear = month;

        startDate = moment(new Date(year, month, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, month + 1, 0)).format("YYYY-MM-DD");
      } else if (event.target.id === "yearOfMonthAndYear") {
        const year = Number(event.target.value);
        const month = this.monthOfMonthAndYear;
        this.yearOfMonthAndYear = year;
        startDate = moment(new Date(year, month, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, month + 1, 0)).format("YYYY-MM-DD");
      } else if (event.target.id === "year") {
        const year = Number(event.target.value);
        this.year = year;
        startDate = moment(new Date(year, 0, 1)).format("YYYY-MM-DD");
        endDate = moment(new Date(year, 12, 0)).format("YYYY-MM-DD");
      }
      this.startDate = startDate;
      this.endDate = endDate;

      const payload = {
        filter_type: this.dateFilterCategory,
        start_date: startDate,
        end_date: endDate,
      };
      const query = {
        page: 1,
      };
      this.transactionHistoryData = [];
      this.currentPage = 1;
      await this.getTrainerTransactionsHistory({ payload, query });
      this.transactionHistoryData =
        this.trainerTransactionsHistory && this.trainerTransactionsHistory.data;
      this.totalPages =
        this.trainerTransactionsHistory &&
        this.trainerTransactionsHistory.last_page;
    },

    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        page,
      };
      const payload = {
        filter_type: this.dateFilterCategory,
        start_date: this.startDate,
        end_date: this.endDate,
      };
      this.transactionHistoryData = [];
      await this.getTrainerTransactionsHistory({ payload, query });
      this.transactionHistoryData =
        this.trainerTransactionsHistory && this.trainerTransactionsHistory.data;
    },
  },
  async created() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    const startDate = moment(new Date(currentYear, currentMonth, 1)).format(
      "YYYY-MM-DD"
    );
    const endDate = moment(new Date(currentYear, currentMonth + 1, 0)).format(
      "YYYY-MM-DD"
    );
    this.yearOfMonthAndYear = currentYear;
    this.monthOfMonthAndYear = currentMonth;
    this.startDate = startDate;
    this.endDate = endDate;

    const payload = {
      filter_type: "month",
      start_date: startDate,
      end_date: endDate,
    };
    const query = {
      page: this.currentPage,
    };
    await this.getTrainerTransactionsHistory({ payload, query });
    this.transactionHistoryData =
      this.trainerTransactionsHistory && this.trainerTransactionsHistory.data;
    this.totalPages =
      this.trainerTransactionsHistory &&
      this.trainerTransactionsHistory.last_page;
  },
};
</script>